import * as React from "react";
import {inject, observer} from "mobx-react";
import {Router as Router} from "react-router-dom";
import Master from "@templates/master";
import Grid from "@components/Grid/Grid"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'


class LeftMenu2 extends React.Component {
    constructor(props) {

        super(props);
        this.navigateToSiteUrl = this.navigateToSiteUrl.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);

        this.state = {
            menuOpen: false
        }
    }

    navigateToSiteUrl(event, url, name) {
        event.preventDefault();
        this.props.navigation.navigateToSiteUrl(this.props.tree, url, name);
        this.props.navigation.closeToolbar();
        this.setState({menuOpen: false});
    }

    toggleMenu(e) {
        this.setState({menuOpen: !this.state.menuOpen});
    }


    render() {
        if (!this.props.parent) {
            return null;
        }

        return (
            <ul className={"left-menu " + (this.state.menuOpen ? "menu-open" : "")}>
                <li key={"menu-toggle"}
                    className="menu-item-toggle"
                >
                    <h3>{this.props.parent.Name} {this.props.navigation.isMobile &&
                        <a href="#" onClick={this.toggleMenu}><FontAwesomeIcon icon={["fas", "bars"]}
                                                                               className={"toggle "}
                                                                               size="sm"/></a>}</h3>
                </li>
                {this.props.parent.ChildrenView().map(node => {
                    //console.log("child page",node);
                    //const isHeading = node.Alias === "icom_menuHeading";
                    return (
                        <li key={node.Id}
                            className={(node.IsHeading ? "menu-heading" : "") + " menu-item"}>
                            {node.IsHeading || node.Alias === "PageGroup"
                                ? <h4>{node.Name}</h4>
                                :
                                <a href={node.Url} className={node.Id === this.props.navigation.NodeId ? "active" : ""}
                                   onClick={event => this.navigateToSiteUrl(event, node.Url, node.Name)}
                                ><span>{node.Name}</span></a>

                            }

                        </li>
                    );
                })
                }
            </ul>

        );
    }
}

@inject("store")
@observer
export default class SimplePage extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        const pageContent = this.props.navigation.pageContent.Properties;
        const parent = this.props.navigation.CurrentNode ? this.props.navigation.CurrentNode.Name === "Chokopedia" ? this.props.navigation.CurrentNode : this.props.navigation.CurrentNode.Parent : null;
        return (
            <Master {...this.props}>
                <div className="wrapper">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 col-lg-3">
                                <LeftMenu2 navigation={this.props.navigation} parent={parent}/>
                            </div>
                            <div className="col-12 col-lg-9">
                                <Grid {...this.props} model={pageContent.grid}/>
                                <div
                                    dangerouslySetInnerHTML={{__html: pageContent.bodyText}}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </Master>
        );
    }
}

